import {Component, Input, Output, ViewChild, EventEmitter, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import { IrbCommonModule } from "@irb/irb-common/irb-common.module";
import { IPortfolioResultChartConfig } from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import { IDropdownItem } from "@irb/irb-common/models/dropdown.model";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IrbEditorComponent} from "@irb/irb-editors/irb-editors.com";
import {IrbDialogsEvents} from '@irb/irb-dialogs/irb-dialogs.events';
import { ComPrAllocationChartGroupComponent } from '@irb/irb-editors/editor-portfolio-result/com-pr-allocation-chart-group/com-pr-allocation-chart-group.component';
import { JasperSettings, ISortModel } from "@irb/irb-dialogs/dialog-pr-export-pdf/dialog-pr-export-pdf.component";

@Component({
  selector: 'irb-com-pr-allocation-chart',
  templateUrl: './com-pr-allocation-chart.component.html',
  styleUrls: ['./com-pr-allocation-chart.component.scss'],
  standalone: true,
  imports: [ComPrAllocationChartGroupComponent, CommonModule, IrbCommonModule]
})
export class ComPrAllocationChartComponent extends IrbEditorComponent implements OnInit {
  @Input("showCustomView") showCustomView: boolean;
  @Input() pdfExportConfig: JasperSettings;
  @Output() pdfExportConfigChange = new EventEmitter<JasperSettings>();
  @ViewChild('chartStyleDropdown') chartStyleDropdown: DropdownFilterComponent;
  @Output() showCustomViewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  chartStyle: IDropdownItem;
  config: IPortfolioResultChartConfig;
  expanded: Object;
  @Input("isPopout") isPopout: boolean = false;
  ENABLE_SEC_GRID_CHART: boolean;

  constructor() {
    super();
  }

  ngOnInit() {
    this.ENABLE_SEC_GRID_CHART = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_SEC_GRID_CHART || false;
    this.config = this.pdfExportConfig.allcnChartConfig;

    this.expanded = {
      "POSITION": true,
      "SEC_CATEGORY": true,
      "SEC_TYPE": true,
      "SAC": true,
      "STYLE_BOX": true
    };

    let c =  window.localStorage.getItem("PRD_ALLOCATION_CHART_CONFIG");

    if(c && this.util.compareObjectKeys(this.config, JSON.parse(c))) {
        this.config = JSON.parse(c);
  }

    let e =  window.localStorage.getItem("PRD_ALLOCATION_CHART_EXPAND");
    this.expanded = (e) ? JSON.parse(e) : this.expanded;

    this.chartStyle = (this.config.chartStyle == 'BAR_CHART') ? {name: "Bar Chart", value: "BAR_CHART"} : {name: "Donut Chart", value: "PIE_CHART"};
    this.onInputChange();
  }

  onDataChange() {
    this.data = {...this.data};
  }

  setChartStyleDropdown(_searchStr: any) {
      this.chartStyleDropdown.set([
          {name: "Bar Chart", value: "BAR_CHART"},
          {name: "Donut Chart", value: "PIE_CHART"}
      ]);
  }

  onInputChange() {
    window.localStorage.setItem("PRD_ALLOCATION_CHART_CONFIG", JSON.stringify(this.config));
    window.localStorage.setItem("PRD_ALLOCATION_CHART_EXPAND", JSON.stringify(this.expanded));

    if(this.pdfExportConfig) {
      this.pdfExportConfig.allcnChartConfig = this.config;
      this.pdfExportConfigChange.emit(this.pdfExportConfig);
          }

    this.config = { ...this.config };
  }

  onChartStyleChange() {
      this.config.chartStyle = this.chartStyle.value;
      this.onInputChange();
  }

  toggleCustomView() {
    this.showCustomView = !this.showCustomView;
    this.showCustomViewChange.emit(this.showCustomView);
  }

  hideCustomView() {
    this.showCustomView = false;
    this.showCustomViewChange.emit(false);
  }

  expandAll() {
    for(const key in this.expanded) {
      this.util.setObjectValue(this.expanded, key, true);
    }

    this.onInputChange();
  }

  collapseAll() {
    for(const key in this.expanded) {
      this.util.setObjectValue(this.expanded, key, false);
    }

    this.onInputChange();
  }

  showModelHistoryInRebalance() {
      let dialogData = {
          portfolioResultData: this.data
      }
      this.as.fireEvent(IrbDialogsEvents.SHOW_MODEL_USED_IN_REBALANCE_DIALOG, dialogData);
  }

  onConfigChange(c: IPortfolioResultChartConfig) {
    this.pdfExportConfig.allcnChartConfig = c;
    this.pdfExportConfigChange.emit(this.pdfExportConfig);
    this.config = c;
    this.onInputChange();
  }
}
